import React from 'react';
import styled, { css } from 'styled-components';
import { Link, useHistory } from 'react-router-dom';

type ButtonProps = { to?: string, fullWidth?: boolean, active?: boolean };

type ButtonWithHtmlProps = ButtonProps & React.HTMLProps<HTMLButtonElement>;

export const Button =
    styled.button <
    ButtonWithHtmlProps >
    `
    border-radius: 5px;
    padding: 0;
    font: inherit;
    color: inherit;
    padding: 10px;
    text-align: center;
    cursor: pointer;
    border: 1px solid black;
    text-decoration: none;
    font-weight: 600;
    text-transform: uppercase;
    color: black;
    background-color: ${(props) =>
        props.disabled
            ? 'lightgray'
            : props.active
            ? props.theme.colors.blue
            : props.theme.colors.green};
    width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
`;

export const LinkButton: React.FC<ButtonProps & React.HTMLProps<HTMLButtonElement>> = ({
    to,
    disabled,
    active,
    children,
    fullWidth,
    onClick,
}) => {
    const history = useHistory();
    return (
        <Button
            active={active}
            fullWidth={fullWidth}
            disabled={disabled}
            children={children}
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
                if (to && !disabled) {
                    history.push(to);
                }
            }}
        />
    );
};

